import $ from 'jquery';

const initColorChoices = function() {
  const choiceSelector = '.en_mdl_article_detail__color_choice';
  const valSelector = '.en_mdl_article_detail__chosen_color_val';

  document.addEventListener( 'mouseenter', setColor, true );
  document.addEventListener( 'mouseleave', setColor, true );

  document.addEventListener( 'click', e => {
    let choiceEl = e.target;

    while( choiceEl.parentNode.tagName != 'HTML' ) {
      if(
        choiceEl.matches( choiceSelector ) &&
        !choiceEl.classList.contains( 'is_selected' ) &&
        EN.Media.matches( null, 'desktop' )
      ) {
        window.scrollTo( { top: 0, behavior: 'smooth' } );
        return;
      }
      choiceEl = choiceEl.parentNode;
    }
  } );

  function setColor( e ) {
    if( e.target === document || !e.target.matches( choiceSelector ) ) return;
    const choiceEl = e.target;
    const valEl = choiceEl.closest( '.en_mdl_article_detail__color' ).querySelector( valSelector );
    if( e.type === 'mouseenter' ) valEl.textContent = choiceEl.dataset.colorName;
    if( e.type === 'mouseleave' ) valEl.textContent = valEl.dataset.colorNameDefault;
  }
}

$( document ).ready( function() {
  initColorChoices();
} );

